export class UserModel {
    id: number;
    login: string;
    name: string;
    surname: string;
    title: string;
    titleAfter: string;
    activeStatusCode: string;
    employmentCode: string;
    email: string;
    employmentDate: string;
    facultyId?: number;
    facultyCode: string;
    facultyName?: string;
    workCenterId?: string;
    workCenterCode: string;
    workCenterName?: string;
    studyProgramId?: string;
    studyProgramName?: string;
    studyDepartmentCode?: string;
    studyDepartmentName?: string;
    fieldOfStudyCode1?: string;
    fieldOfStudyName1?: string;
    photoOID: string;
    phone: string;
    historicalParentId: number;
    createdDatetime: string;
    rolesAsString: string;
    userId?: number;
    isExternal?: boolean;
    role?: number;
    createdById?: number;
    updatedDatetime?: string;
    updatedById?: number;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/user.model.ts